import { render, staticRenderFns } from "./entityDialog.vue?vue&type=template&id=20147c5c&scoped=true&"
import script from "./entityDialog.vue?vue&type=script&lang=js&"
export * from "./entityDialog.vue?vue&type=script&lang=js&"
import style0 from "./entityDialog.vue?vue&type=style&index=0&id=20147c5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20147c5c",
  null
  
)

export default component.exports